// extracted by mini-css-extract-plugin
export default {"PageContainer":"LoginPage_PageContainer__clxlQ","ContentContainer":"LoginPage_ContentContainer__vyIGs"};